import PropTypes from 'prop-types';
import React from 'react';
import CardField from './CardField';
import styles from './CardField.scss';
import _ from 'lodash';

export default class CardCheckbox extends React.Component {

  static propTypes = {
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    name: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string
  };

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  onChange(e) {
    this.props.onChange(e.target.checked);
  }

  render() {
    const rest = _.omit(this.props, 'onChange', 'checked', 'type');

    return (
      <CardField onChange={() => {}} {...rest}>
        <div className={`ui fitted checkbox ${styles.checkboxOffset}`}>
          <input
            type='checkbox'
            tabIndex={0}
            onChange={this.onChange}
            checked={this.props.checked}
            {...rest}
          />
          <label></label>
        </div>
      </CardField>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardCheckbox.js